import { message } from "antd";



export const fetchTest = async (setTest, baseUrl, prodTestUrl) => {
 
  try {
    const response = await fetch(
      `${prodTestUrl ? prodTestUrl : baseUrl}/api/admin-get-all-tests/`
    );
    if (response.ok) {
      const data = await response.json();
      setTest(data);
    } else {
      message.error("Failed to fetch test.");
    }
  } catch (error) {
    message.error("An error occurred while fetching test.");
  }
};